import GameTaggingBackground from 'components/images/homePage/gameTaggingBackground.jpg';
import { ServiceTypes } from 'constants/ServiceTypes';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { ConfigurationService } from 'services/ConfigurationService';
import { useInjection } from 'services/ioc/ioc.react';
import { ContextualDataStore } from 'stores/ContextualDataStore';
import { SessionStore } from 'stores/SessionStore';
import { TrackingElementsStore } from 'stores/TrackingElementsStore';
import { ContextStore } from '../../../../stores/ContextStore';
import { GameCardOverlay } from '../GameCardOverlay/GameCardOverlay';
import GameInProgressCard from '../GameInProgress/GameInProgressCard';
import { HomeMenuCard } from '../HomeMenuCard/HomeMenuCard';
import { OrgInfoCard } from '../OrgInfoCard/OrgInfoCard';
import { GameTaggingWrapper, Overlay, Text, TextWrapper, Title, UpcomingGame } from './GameTaggingStyles';

interface IProps {
  allowStartingNewGame: boolean;
}

export const TagGames: React.FC<IProps> = (props) => {
  const { allowStartingNewGame } = props;
  const contextStore = useInjection<ContextStore>(ServiceTypes.ContextStore);
  const sessionStore = useInjection<SessionStore>(ServiceTypes.SessionStore);
  const configurationService = useInjection<ConfigurationService>(ServiceTypes.ConfigurationService);
  const [nextGameStartingIn, setNextGameStartingIn] = useState<string>('');
  const contextualDataStore = useInjection<ContextualDataStore>(ServiceTypes.ContextualDataStore);
  const trackingElementsStore = useInjection<TrackingElementsStore>(ServiceTypes.TrackingElementsStore);
  const history = useHistory();

  const config = configurationService.getConfigs();
  let interval: ReturnType<typeof setInterval>;

  useEffect(() => {
    interval = setInterval(() => {
      setNextGameStartingIn(contextualDataStore.getNextGameStartingIn());
    }, 1000);
    setNextGameStartingIn(contextualDataStore.getNextGameStartingIn());
    return (): void => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, []);

  return (
    <GameTaggingWrapper>
      <HomeMenuCard
        onClickCallback={(): void => {
          if (allowStartingNewGame) {
            history.push('/games');
          }
        }}
        backgroundImage={GameTaggingBackground}
        height='448px'
        cardClassName='game-tagging'
        data-test='game-tagging'
        width='100%'
        style={{
          backgroundPosition: 'center',
          backgroundSize: 'cover',
        }}
      >
        <Overlay />

        <OrgInfoCard />
        {!allowStartingNewGame && !sessionStore.isGameInProgress && (
          <GameCardOverlay
            isConnectedToRadar={contextStore.isConnectedPtu}
            isGameActive={sessionStore.isGameInProgress}
            isActiveFieldPresent={!!contextStore.activeField}
            isLoggedIn={contextStore.isLoggedIn}
            isBackfield={!!config?.isBackfield}
            managementAppUrl={`${configurationService.getWindowOrigin(false)}/managementapp`}
            updating={trackingElementsStore.updating}
          />
        )}
        <TextWrapper>
          <Title>Tag games</Title>
          <Text>and view the daily schedule</Text>
          {!sessionStore.isGameInProgress && contextualDataStore.getNextGame() && (
            <UpcomingGame>The next game will start {nextGameStartingIn}</UpcomingGame>
          )}
        </TextWrapper>
      </HomeMenuCard>
      {sessionStore.isGameInProgress && <GameInProgressCard />}
    </GameTaggingWrapper>
  );
};
